const ADD_ITEM_GROUP_FORM_TEMPLATE ={
    modalTitle: "New Item Group",
    path: "/itemgroups",
    listPage: "/list-item-groups",
    bodySections: {
      basic: {
        sectionType: "basic",
        sectionTypeId: "basic",
        expandable: false,
        position: "LAST",
        breakPoint: 0,
        fieldName: "itemGroup",
        fieldItems: [
          {
            label: "Item Group Name",
            type: "text",
            name: "itemGroup",
            initialFocus: true,
            validationProps: {
              required: "Item group is required"
            }
          }
        ]
      }
    }
}

export default ADD_ITEM_GROUP_FORM_TEMPLATE;